/**
 * lib/metaPage.js — description, adresse canonique et consigne d'indexation de la page affichée.
 * Appelé par components/SuiviPages.js à chaque changement de route.
 */
import { SITE } from './titresPages';

function balise(selecteur, creer) {
  const existante = document.head.querySelector(selecteur);
  if (existante) return existante;
  const el = creer();
  document.head.appendChild(el);
  return el;
}

function meta(attribut, cle, valeur) {
  const el = balise(`meta[${attribut}="${cle}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute(attribut, cle);
    return m;
  });
  el.setAttribute('content', valeur);
}

export function poserMeta({ titre, description, chemin, indexable }) {
  if (typeof document === 'undefined') return;
  document.title = titre;
  meta('name', 'description', description);
  meta('property', 'og:title', titre);
  meta('property', 'og:description', description);
  const url = `${SITE}${chemin === '/' ? '/' : chemin}`;
  meta('property', 'og:url', url);
  const lien = balise('link[rel="canonical"]', () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  });
  lien.setAttribute('href', url);
  meta('name', 'robots', indexable ? 'index, follow' : 'noindex, follow');
}
